import styled, { css } from 'styled-components'

export const HomeCloudSoftwareHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const HomeSoftwareVersion = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const HomeSoftwareRowStyles = css`
  height: auto;
  min-height: 40px;
`
